import { Text } from '@belong/ui';
import { twMerge } from 'tailwind-merge';

type List = {
  name: string;
  tag: string;
  tagColor: string;
};

type TagListProps = {
  list: List[];
};

export function TagList({ list }: TagListProps) {
  return (
    <div className="gap-x-sm grid grid-cols-1 md:grid-cols-2">
      {list.map(({ name, tag, tagColor }, index) => (
        <div className="mt-2xs flex justify-between" key={index}>
          <Text fontWeight="semibold">• {name}</Text>
          <Text
            variant="p1"
            fontWeight="semibold"
            className={twMerge('rounded-small px-xs text-white', tagColor)}
            style={{ height: 20 }}
          >
            {tag}
          </Text>
        </div>
      ))}
    </div>
  );
}
